/* global CustomEvent */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import 'custom-event-polyfill/polyfill';
import css from './index.scss';
import Button from '../button';
import { Cross } from '../../helpers/icon-dictionary';

class TextInput extends PureComponent {
    constructor(props) {
        super(props);

        this.handleClearText = this.handleClearText.bind(this);
    }

    handleClearText() {
        const { clearText, handleOnChange } = this.props;
        if (clearText && this.inputEl.value !== '') {
            this.inputEl.value = '';
            const event = new CustomEvent('input', { bubbles: true });
            this.inputEl.dispatchEvent(event);
            handleOnChange(event);
        }
    }

    render() {
        const { clearText, handleOnChange, handleOnBlur, handleOnKeyPress } = this.props;

        let inputProps = {};
        let clearEl = '';
        let hasClearText = '';

        // Add ref to the input component if clear text mode is enabled
        if (clearText) {
            hasClearText = this.props.css.hasClearText;
            inputProps = { ref: (el) => { this.inputEl = el; } };
            clearEl = (<Button
                containerClassName={this.props.css.clearButtonContainer}
                disabled={this.props.disabled}
                handleOnClick={this.handleClearText}
                icon={Cross}
                iconClassName={this.props.css.clearButtonIcon} />);
        }

        return (
            <div className={`${this.props.css.inputTextComponent} ${hasClearText}`}>
                <input
                    className={this.props.css.inputText}
                    disabled={this.props.disabled}
                    maxLength={this.props.maxLength}
                    name={this.props.name}
                    onBlur={handleOnBlur}
                    onChange={handleOnChange}
                    onKeyPress={handleOnKeyPress}
                    placeholder={this.props.placeholder}
                    type={this.props.type}
                    value={this.props.value}
                    {...inputProps}
                />{clearEl}
            </div>
        );
    }
}

TextInput.defaultProps = {
    type: 'text'
};

TextInput.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    css: PropTypes.object,
    handleOnChange: PropTypes.func,
    disabled: PropTypes.bool,
    // Enable clear text mode and display a clear button
    clearText: PropTypes.bool,
    type: PropTypes.string,
    handleOnBlur: PropTypes.func,
    handleOnKeyPress: PropTypes.func
};

export default styleable(css)(TextInput);




// WEBPACK FOOTER //
// ./app/components/text-input/index.js